import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import CloseIcon from '@material-ui/icons/Close';
// import GetAppRoundedIcon from '@material-ui/icons/GetAppRounded';
import IconButton from '@material-ui/core/IconButton';
import MailRoundedIcon from '@material-ui/icons/MailRounded';
import PhoneRoundedIcon from '@material-ui/icons/PhoneRounded';
import ShareIcon from '@material-ui/icons/Share';

import DatabaseIcon from '../icons/DatabaseIcon.jsx';
import WebIcon from '../icons/WebIcon.jsx';
import ServicestackIcon from '../icons/Servicestack.jsx';
import AppIcon from '../icons/AppIcon.jsx';

const useStyles = makeStyles((theme) => ({
  fullList: {
    width: 350,
    height: 1008,
    padding: theme.spacing(1, 1, 0, 2),
    marginBottom: theme.spacing(3),
  },
  divider: {
    margin: theme.spacing(2, 0, 3, 0),
  },
  detailsText: {
    fontSize: theme.spacing(3),
    color: theme.palette.primary.main,
    marginTop: theme.spacing(3),
  },
  button: {
    fontSize: theme.spacing(2),
    width: theme.spacing(21),
    height: theme.spacing(5),
    margin: theme.spacing(1, 1, 1, 0),
  },
  downloadButton: {
    fontSize: theme.spacing(2),
    height: theme.spacing(5),
    margin: theme.spacing(1.5, 2, 3, 0),
  },
  appInfo: {
    textAlign: 'left',
    marginBottom: theme.spacing(1),
  },
  centerInfoText: {
    color: theme.palette.primary.main,
    marginTop: theme.spacing(1.5),
  },
  appInfoText: {
    fontSize: theme.spacing(1.8),
    color: theme.palette.primary.main,
    marginTop: theme.spacing(3),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1.5),
    color: theme.palette.neutral.main,
  },
  closeIcon: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
  },
  inlineIcon: {
    width: theme.spacing(4),
    height: theme.spacing(2.5),
    verticalAlign: 'middle',
    paddingRight: theme.spacing(1.5),
  },
}));

const HelpCenter = (props) => {
  const classes = useStyles();

  const openKnowledgeBase = () => {
    window.open('https://matrixsys.helpdocs.io/', '_blank');
  };

  const openWhatsNew = () => {
    window.open('https://matrixsys.helpdocs.io/article/hdak446vm3-premisys-readme-file');
  };

  // const openAPIDocs = () => {
  //   window.open('http://apiportal.identicard.com/');
  // };

  const openHelpDesk = () => {
    window.open('https://identicard.com/pages/self-service-for-technical-assistance-new');
  };

  return (
    <div className={classes.fullList} role="presentation">
      <IconButton className={classes.closeButton} onClick={props.handleClose}>
        <CloseIcon className={classes.closeIcon} color="primary" />
      </IconButton>
      <div className={classes.button}>
        <Typography variant="h5" color="primary">
          Help Center
        </Typography>
      </div>
      <Button
        className={classes.button}
        variant="contained"
        color="secondary"
        endIcon={<ShareIcon />}
        onClick={openKnowledgeBase}
      >
        Knowledge Base
      </Button>
      <div className={classes.detailsText}>
        <Typography variant="body2">Visit the Knowledge Base for General FAQ & support </Typography>
      </div>
      <div className={classes.divider}>
        <Divider />
      </div>
      <Button
        className={classes.button}
        variant="contained"
        color="secondary"
        onClick={openWhatsNew}
        endIcon={<ShareIcon />}
      >
        What's New ?
      </Button>
      {/* <Button
        className={classes.button}
        variant="contained"
        color="secondary"
        onClick={openAPIDocs}
        endIcon={<ShareIcon />}
      >
        API Docs
      </Button> */}
      {/* <Button
        className={classes.button}
        variant="contained"
        color="secondary"
        onClick={openHelpDesk}
        endIcon={<ShareIcon />}
      >
        Help Desk
      </Button> */}
      {/* <Button
        className={classes.button}
        variant="contained"
        color="secondary"
        endIcon={<ShareIcon />}
      >
        Status Center
      </Button> */}
      <div className={classes.divider}>
        <Typography variant="h6" display="block">
          Support Contact Information
        </Typography>
        <Typography variant="h6" display="block">
          Matrix Systems
        </Typography>
        <Typography variant="subtitle2" display="block" className={classes.centerInfoText}>
          <PhoneRoundedIcon className={classes.inlineIcon} color="secondary" />
          US Tech Support: 1-800-562-3343
        </Typography>
        <Typography variant="subtitle2" display="block" className={classes.centerInfoText}>
          <MailRoundedIcon className={classes.inlineIcon} color="secondary" />
          Tech Support Email:{' '}
          <Link color="secondary" href="mailto:premisyssupport@acre-co.com">
            premisyssupport@acre-co.com
          </Link>
        </Typography>
      </div>
      {/* <Button
        className={classes.downloadButton}
        variant="contained"
        color="secondary"
        endIcon={<GetAppRoundedIcon />}
      >
        Download Tech Support Information
      </Button> */}
      <div className={classes.divider}>
        <Divider />
      </div>
      <div className={classes.divider}>
        <Typography variant="h6">Diagnostic Information</Typography>
        <div className={classes.appInfo}>
          <Typography className={classes.appInfoText}>
            <AppIcon className={classes.inlineIcon} color="secondary" />
            {`App Version - ${process.env.REACT_APP_VERSION ?? 'development'}`}
          </Typography>
          <Typography className={classes.appInfoText}>
            <DatabaseIcon className={classes.inlineIcon} color="secondary" />
            DB Version - 2.0.0.84984-az17195
          </Typography>
          <Typography className={classes.appInfoText}>
            <ServicestackIcon className={classes.inlineIcon} color="secondary" />
            Service Stack - Hybrid
          </Typography>
          <Typography className={classes.appInfoText}>
            <WebIcon className={classes.inlineIcon} color="secondary" />
            Browser Version -{' '}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default HelpCenter;
